import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CXL, H2 } from "@/components/Typography";
import Device from "@/utils/device";

const BenefitsContent: FunctionComponent = () => {
  return (
    <S.Section data-cy="SF-content-2023">
      <S.CopyContainer>
        <H2>
          <S.BoldWrap>
            Unlock the Benefits of AllBright <br />
          </S.BoldWrap>
          <S.ItalicWrap>Membership</S.ItalicWrap>
        </H2>
        <CXL>
          Your AllBright@ Old Sessions House membership provides endless
          opportunities to grow, connect, and thrive within a vibrant community.
        </CXL>
        <CXL>
          Beyond the stunning facilities, this membership connects you to a
          world of enriching events, workshops, and networking opportunities,
          designed to elevate both your personal and professional journey.
        </CXL>
        <CXL weight={700}>Your membership benefits include...</CXL>
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 3% 10% 10% 10%;
  background: ${colours.shell};
  display: flex;
  flex-direction: column;

  @media ${Device.tablet} {
    padding: 4% 10%;
  }
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.CopyContainer = styled.div`
  margin: 30px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 20px;

  > ${CXL} {
    line-height: 2rem;
  }

  @media ${Device.mobile} {
    gap: 30px;

    > ${CXL} {
      line-height: 2.5rem;
    }
  }

  @media ${Device.desktop} {
    margin: 0 60px 0 0;
    gap: 20px;

    > ${CXL} {
      line-height: 2.8rem;
    }
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
  font-size: 3rem;

  @media ${Device.mobile} {
    font-size: 4rem;
    line-height: 2rem;
  }

  @media ${Device.tablet} {
    font-size: 5rem;
    line-height: 5rem;
  }
`;

S.BoldWrap = styled.span`
  font-weight: 700;
  font-size: 2rem;
  line-height: 1rem;

  @media ${Device.mobile} {
    font-size: 2.5rem;
    line-height: 1.5rem;
  }

  @media ${Device.tablet} {
    font-size: 4rem;
    line-height: 2rem;
  }
`;

export default BenefitsContent;
